import { Routes } from '@angular/router';
import { AdmpublicationsListComponent } from './admpublications-list/admpublications-list.component';
import { AdmpublicationsFormComponent } from './admpublications-form/admpublications-form.component';
import { AdmFormIntroInfoComponent } from '../shared/adm-form-intro-info/adm-form-intro-info.component';
import { AdmpublicationsFormYoutubeComponent } from './admpublications-form-youtube/admpublications-form-youtube.component';
import { AdmpublicationsFormPdfComponent } from './admpublications-form-pdf/admpublications-form-pdf.component';
import { AdmpublicationsFormCarouselComponent } from './admpublications-form-carousel/admpublications-form-carousel.component';


export const ADMPUBLICATIONS_ROUTES: Routes = [
    { path: 'list', component: AdmpublicationsListComponent },
    { path: 'add', component: AdmpublicationsFormComponent },
    { path: 'edit/:id', component: AdmpublicationsFormComponent },
    { path: 'edit-yt/:id', component: AdmpublicationsFormYoutubeComponent },
    { path: 'edit-pdf/:id', component: AdmpublicationsFormPdfComponent },
    { path: 'edit-sdr/:id', component: AdmpublicationsFormCarouselComponent },
    { path: 'add-info/:id', component: AdmFormIntroInfoComponent },
    { path: '**', pathMatch: 'full', redirectTo: 'list' }
];